import React from 'react';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants';
import { getColorFromEvent, getIconFromModel } from '../../helpers/events';
import { prettyKey } from '../../helpers/formatters';

const UserLogItem = ({ log, user, users }) => {
  const actorId = log.actor_id ? log.actor_id.toString().split(':')[1] : null;
  let actorUser;
  if (actorId && Number.isInteger(parseInt(actorId, 10))) {
    actorUser = users.find((u) => u.id.toString() === actorId);
  }
  return (
    <div className={`user-log-item bg-${getColorFromEvent(log.event)}`}>
      <div className="col-xs-2 user-log-item-model">
        <span className={`glyphicon ${getIconFromModel(log.model)}`}></span>
        <div>{log.model}</div>
      </div>
      <div className="col-xs-10">
        <div>
          <strong>ID:</strong> {log.id}
        </div>
        <div>
          <strong>Event:</strong> {log.event}
        </div>
        <div>
          <strong>Model:</strong> {log.model}
        </div>
        <div>
          <strong>Model ID:</strong> {log.model_id}
        </div>
        <div>
          <strong>Owner ID:</strong> {prettyKey(log.owner_id)}
        </div>
        <div>
          <strong>Actor ID:</strong> {prettyKey(log.actor_id)}
          {actorUser && (
            <span>
              &nbsp; - {actorUser.first_name} {actorUser.last_name} -{' '}
              {actorUser.acl_group_name}
            </span>
          )}
        </div>
        <div>
          <strong>Event Time:</strong>{' '}
          {moment(log.event_ts).format(DATE_TIME_FORMAT)}
        </div>
        <div>
          <strong>Event Source:</strong> {log.event_src}
        </div>
        <div>
          <strong>Request Source:</strong> {log.request_source}
        </div>
        <div>
          <strong>Details:</strong> {log.details}
        </div>
      </div>
    </div>
  );
};

export default UserLogItem;
